import React, { useState, useEffect } from 'react';
import {
    Modal, ResourceList, ResourceItem, Thumbnail, TextStyle, Spinner
} from '@shopify/polaris';
import Product from '../../types/product';

function ProductSelectModal(props: any){
    const [selectedItem, setSelectedItem] = useState<Product | null>(null);
    const [selectedItems, setSelectedItems] = useState<string[]>([]);
    const spinnerContainerStyle = {
        textAlign: 'center' as const,
        padding: '20px',
    };

    const {
        isLoading,
        active,
        title,
        items,
        onPrimaryButtonClick,
        OnClose,
        multiSelection,
        onItemSelection,
        defaultSelectedItems,
        onSelectionChange
    } = props;

    useEffect(() => {
        if( !!multiSelection ){
            //multi select modal
            if( defaultSelectedItems )
                setSelectedItems(defaultSelectedItems.map((item: Product) => item.id));
        }
    }, [defaultSelectedItems, multiSelection]);

    const renderItem = (item: any) => {
        const {id, image, title, variant_length} = item;
        const noOfVariants = `${variant_length} variants`;
        return (
            <ResourceItem
            id={id}
            onClick={(id: string) => {
                if( !multiSelection ) {
                    const selectedProd = items.find( (itm: any) => { return itm.id === Number(id) });
                    setSelectedItem(selectedProd ? selectedProd : null);
                }
            }}
            media={<Thumbnail source={image ? image.src : window.location.origin +  '/placeholder.png'} alt={title} />}
            accessibilityLabel={`View details for ${title}`}
            name={title}
            >
                <h3>
                    <TextStyle variation="strong">{title}</TextStyle>
                </h3>
                <div>{noOfVariants}</div>
                {!multiSelection && selectedItem && (item.id === selectedItem.id) ? <div className="resourceItemSelected">SELECTED</div> : ''}
            </ResourceItem>
        );
    };

    return (
        <Modal
                open={active}
                title={title}
                primaryAction={{
                    content: 'Select',
                    onAction: () => {
                        if( !!multiSelection ) {
                            //multi select
                            onPrimaryButtonClick(items.filter((item: Product) => {
                                return selectedItems.find(selectedItem => Number(selectedItem) === item.id);
                            }));
                        } else {
                            //single select
                            onItemSelection(selectedItem);
                            onPrimaryButtonClick();
                        }
                    },
                }}
                onClose={OnClose}>

            { isLoading ? (<div style={spinnerContainerStyle}><Spinner accessibilityLabel="Loading Products" size="large" /></div>) :
                        items && items.length > 0 ? (
                        <ResourceList
                            resourceName={{singular: 'Product', plural: 'Products'}}
                            items={items}
                            selectable={!!multiSelection}
                            selectedItems={selectedItems}
                            onSelectionChange={(items: any[]) => {
                                if( !!multiSelection ) {
                                    setSelectedItems(items);
                                    onSelectionChange();
                                }
                            }}
                            renderItem={renderItem} />) : (
                        <div>No products available!</div> )
            }
        </Modal>
    );
}

export default ProductSelectModal;